#@import GliveBooking.Views.Picker
#@import GliveBooking.Presenters.DatePicker
#@import GliveBooking.Views.Calendar
#@export GliveBooking.Views.DatePicker

class GliveBooking.Views.DatePicker extends GliveBooking.Views.Picker

  module: 'glive-booking'

  presenter: GliveBooking.Presenters.DatePicker

  contentView: GliveBooking.Views.Calendar

  templateName: 'datepicker'

  attributes: ->
    'data-bhw': "#{GliveBooking.bhw}Dates"

  styleClassName: 'dates'

  refreshDates: ->
    @content().$el.detach()
    @_content = new @contentView({collection: @collection, selected: @selected})
    @_content.on 'select', @select, this
    @_content.render()
    @appendContent()

  setSelection: (selection) ->
    @model.set(selectedDate: { date: @collection.first().start() }) if @collection.length == 1
